export const Users = [
    {
      id:1,
      profilePicture: "img1.jpg",
      username: "Safak Kocaoglu",
    },
    {
      id:2,
      profilePicture: "img2.jpg",
      username: "Janell Shrum",
    },
    {
      id:3,
      profilePicture: "img3.jpg",
      username: "Alex Durden",
    },
    {
      id:4,
      profilePicture: "img2.jpg",
      username: "Dora Hawks",
    },
    {
      id:5,
      profilePicture: "img3.jpg",
      username: "Thomas Holden",
    },
    {
      id:6,
      profilePicture: "img2.jpg",
      username: "Shirley Beauchamp",
    },
    {
      id:7,
      profilePicture: "img1.jpg",
      username: "Travis Bennett",
    },
    {
      id:8,
      profilePicture: "img3.jpg",
      username: "Kristen Thomas",
    },
    {
      id:9,
      profilePicture: "img3.jpg",
      username: "Gary Duty",
    },
    {
      id:10,
      profilePicture: "img2.jpg",
      username: "Safak Kocaoglu",
    },
  ];
  
  export const Posts = [
    {
      id: 1,
      desc: "Love For All, Hatred For None.",
      photo: "img2.jpg",
      date: "5 mins ago",
      userId: 1,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: "img1.jpg",
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "Every moment is a fresh beginning.",
      photo: "img3.jpg",
      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: "img2.jpg",
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    {
      id: 5,
      photo: "img3.jpg",
      date: "5 hours ago",
      userId: 5,
      like: 23,
      comment: 5,
    },
    {
      id: 6,
      photo: "img2.jpg",
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "Never regret anything that made you smile.",
      photo: "img2.jpg",
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: "img2.jpg",
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      desc: "Change the world by being yourself.",
      photo: "img2.jpg",
      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      photo: "img2.jpg",
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    },
  ];